export class Formats {
    static DateFormat = "dd/MM/yyyy";
    static DateTimeFormat = "dd/MM/yyyy HH:mm";
    static DateFormatApi = "yyyy-MM-dd";

    static MomentDateFormatApi = "YYYY-MM-DD"; // Moment uses a slightly different format to get the dates.
}
